import { render } from "./articleWidget.vue?vue&type=template&id=57363604&scoped=true"
import script from "./articleWidget.vue?vue&type=script&lang=js"
export * from "./articleWidget.vue?vue&type=script&lang=js"

import "./articleWidget.vue?vue&type=style&index=0&id=57363604&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57363604"]])

export default __exports__